import {POST} from "@/services/gateway";
import {trimString} from "@/components/common/utils/trimString";

const listItems = ({pagination, userIds, snapshotDateTime, folderId, searchTerm}) => {
  return POST('google/calendar/search', {pagination, userIds, snapshotDateTime, folderId, searchTerm: trimString(searchTerm)});
}

// const listSnapshotDetails = ({userIds, folderId, snapshotDateTime, pagination, searchTerm}) => {
//   return POST('google/calendar/search', {userIds, folderId, snapshotDateTime, pagination, searchTerm: trimString(searchTerm)})
// }

const listCalendarBreadcrumps = ({userId, folderId, snapshotDate}) => {
  return POST('google/calendar/breadcrumbs', {userId, folderId, snapshotDate})
}

const exportSnapshot = ({snapshotDateTime, sourceIds, searchTerm, selectedIds, code}) => {
  return POST('google/calendar/export', {snapshotDateTime, sourceIds, searchTerm, selectedIds}, {code: code ? code : null})
}

const restoreSnapshot = ({snapshotDateTime, sourceIds, searchTerm, destinationId, snapshotId, selectedIds, code}) => {
  return POST('google/calendar/restore', {snapshotDateTime, sourceIds, searchTerm, destinationId, snapshotId, selectedIds}, {code: code ? code : null})
}

export {
  listItems,
  // listSnapshotDetails,
  listCalendarBreadcrumps,
  exportSnapshot,
  restoreSnapshot
}
